// extracted by mini-css-extract-plugin
export default {"addNewMember":"assignApprentice_addNewMember__SBIT7","modalBody":"assignApprentice_modalBody__-Uv8j"};